<template>
    <div id="addOrderDiscount">
        <el-card shadow="never">
            <el-row>
                <el-col :span="15" :offset="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" status-icon label-width="100px">
                        <!-- <el-form-item label="类型名称" prop="typeCode">
                            <el-input v-model="ruleForm.typeCode" placeholder="请输入类型编号" :disabled="true"></el-input>
                            <el-cascader
                                placeholder="试试搜索:类型编号"
                                :options="options"
                                v-model="selectedOptions"
                                filterable
                                @change="handleChange" 
                                :disabled="true"
                            >
                            </el-cascader>
                        </el-form-item> -->
                        <el-form-item label="优惠张数" prop="couponCount">
                            <el-input 
                            v-model="ruleForm.couponCount" 
                            placeholder="请输入优惠券张数"
                            :disabled="openDiscount"
                            type="number"></el-input>
                        </el-form-item>
                         <el-form-item label="优惠折扣" prop="discount">
                             <el-col :span="11">
                                 <el-input 
                                    v-model="ruleForm.discount" 
                                    :disabled="openPrice"
                                    @keyup.enter.native="handleClickNum" 
                                    placeholder="请输入优惠折扣"
                                type="number">
                                    <!-- <el-button slot="append">元</el-button> -->
                                </el-input>
                             </el-col>
                            
                        </el-form-item>
                        <el-form-item label="生效日期" prop="effectiveDate">
                            <!-- <el-input v-model="ruleForm.effectiveDate" placeholder="请输入类型名称"></el-input> -->
                            <el-col :span="24">
                                <el-form-item prop="effectiveDate">
                                    <el-date-picker
                                        v-model="ruleForm.effectiveDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions1"
                                        placeholder="选择日期"
                                        :disabled="openDate"
                                        >
                                    </el-date-picker>
                                    <!-- <el-date-picker
                                        v-model="ruleForm.effectiveDate"
                                        style="width: 100%;"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="pickerOptions1"
                                        :default-time="['00:00:00', '00:00:00']"
                                    >
                                    </el-date-picker> -->
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item class="submit">
                            <el-col :span="24">
                                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                                <el-button @click="cancel"> 返回 </el-button>
                                 <el-button @click="addPrice()"> 添加优惠 </el-button>
                            </el-col>
                            
                            <el-col :span="4">
                               
                            </el-col>
                            
                        </el-form-item>
                    </el-form>     
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="23" :offset="1">
                    <!--表格 -->
                    <el-table
                        :data="tableData"
                        height="300"
                        border
                        style="width: 100%">
                        <el-table-column
                        prop="effectiveDate"
                        label="有效日期"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="discount"
                        label="优惠折扣"
                        width="80">
                        </el-table-column>
                        <el-table-column
                        prop="couponCount"
                        label="优惠张数"
                        width="80">
                        </el-table-column>
                        <el-table-column
                        prop="createdTime"
                        label="最后更新日期"
                        width="120"
                        >
                        </el-table-column>
                        <el-table-column
                            prop ="createdBy"
                            label ="最后更新者"
                            width="150"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="operation"
                                label="操作"
                            >
                            <template slot-scope="scope">
                                <el-row>
                                    <el-button-group>
                                        <el-tooltip class="item" effect="dark" content="修改" placement="bottom">
                                            <el-button type="info" @click.native.prevent="revise(scope.$index, tableData)" size="small" plain icon="el-icon-edit"  class="operateBtn">修改</el-button>
                                        </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                            <el-button type="danger" @click.native.prevent="deleteRow(scope.$index, tableData)" size="small" icon="el-icon-delete"  class="operateBtn"></el-button>
                                        </el-tooltip>
                                    </el-button-group>
                                </el-row>
                            </template>                                             
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less">
    .submit{
        margin-top: 30px 0;
    }
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis';
export default {
    mixins:[requestMixin,common],
    inject:['reload'],
    data(){
        var validatePrice = (rule,value,callback) => {
            if(value != ""){
                if((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) == false){
                    callback(new Error("请填写大于0的数字"));
                }else{
                    callback();
                }
            }else{
                callback(new Error("请填写大于0的数字"));
            }
            
        }
        return {
            ruleForm : {
                couponCount :'',
                description :'',
                effectiveDate : '',
                discount : '',
                orderDisId:""
            },
            openPrice:true,
            openDate:true,
            openDiscount:true,
            act : '',
            selectedOptions:[],
            rules : {
                couponCount:[
                    { required : true, message:'请输入优惠张数',trigger: "blur"},
                    { min: 1, max: 4, message: '长度在 1 到 4 个字符', trigger: 'blur' }
                ],
                discount:[
                    { required : true, message:'请输入优惠折扣',trigger: "blur"},
                    { min: 1, max: 3, message: '长度在 1 到 2 个字符', trigger: 'blur' }
                ],
                effectiveDate: [
                    {  required: true, message: '请选择日期', trigger: 'blur' }
                ]
                // price:[
                //     { validator: validatePrice,required :true , trigger: "blur" ,type:'number'},
                //     { min: 1, max: 10, message: '长度在 1 到 10 个数字', trigger: 'blur' }
                // ]
            },
            tableData:[
                
            ],
            options:[
                {
                    value: '001',
                    label: '类型编号0',
                }
            ],
            pickerOptions1 : {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
            }
        }
    },
    mounted(){
        this.$nextTick(() =>{
            let { typeCode } = this.$route.query ;
            this.ruleForm.typeCode = typeCode;
            this.dataNow();
            this.selectTypes();
            //this.refreshType(typeCode);
        })
    },
    methods:{
        dataNow(){
            var d = new Date();
            var r = d.getDate() ;
            var y = d.getFullYear();
            var m = d.getMonth()+1 ;
            m<10 ? m = `0${m}`: m ;
            r<10 ? r = `0${r}`: r
            var dateNow = y+"-"+m+"-"+r;
            this.ruleForm.effectiveDate = dateNow;
            return dateNow
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                let {couponCount,discount,effectiveDate,} = this.ruleForm ;
                //effectiveDate = effectiveDate.split('-').reverse().join('/');
                debugger
                let userId = sessionStorage.getItem("userId") ;
                let params = {
                    act :'addOrderDiscount',
                    couponCount,
                    effectiveDate,
                    discount,
                    userId,
                    orderDisId:this.ruleForm.orderDisId
                }
                let act = this.act;
                if (valid) {
                    if(act){
                        params.act = 'updateOrderDiscount'
                        this.delType(params).then((res) =>{
                            if(res.data.status == true){
                                this.promptMsg('更新成功',"success");
                                this.act = '' ;
                                this.refreshType();
                            }else{
                                res.data.msg ? this.alert(res.data.msg,'warning') : this.alert('添加失败','warning')
                            }
                        })
                    }else{
                        this.delType(params).then((res) => {
                            if(res.data.status == true){
                                this.promptMsg('添加成功',"success");
                                this.reload();
                                let { typeCode }= this.$route.query ;
                                this.refreshType(typeCode);
                            }else{
                                res.data.msg ? this.alert(res.data.msg,'warning') : this.alert('添加失败','warning')
                            }
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        //查找类型编号
        selectTypes(){
            let userId = sessionStorage.getItem("userId") ;
            let params = {
                act:'findOrderDiscounts',
                userId
            }
            this.findType(params).then( (res) =>{
                    if(res.data.status==true){
                        this.tableData=res.data.list
                    }
                // if(res.data.status == true){
                //     let resultData = res.data.list;
                //     let options = [];
                //     for(let [index,val] of resultData.entries()){
                //         options.push({
                //                 value : val.typeCode  ,
                //                 label : val.description //显示的label
                //             }) 
                //     }
                //     this.options = options;
                //     let index = this.$route.query.index;
                //     this.selectedOptions.push(options[index].value)[0];
                //     this.selectedOptions.push(options[index].label)[1];
                //     this.ruleForm.discount = this.selectedOptions[0];
                //     this.ruleForm.couponCount = this.selectedOptions[1];
                // }else{

                // }
            })
        },
        cancel(value) {
            this.$router.go(-1)
        },
        //添加订单优惠折扣
        addPrice(){
            this.openPrice = false;
            this.openDate = false;
            this.openDiscount=false;
        },
        /* ------------------ 表格 -------------------- */
        //加载表格数据
        refreshType(){
            this.loadTypes('findOrderDiscounts').then((res) => {
                if(res){
                    // let result = res.filter( (elem,index,arr) => typeCode == elem.typeCode);
                    // for(let i =0;i<result.length;i++){
                    //     result[i].lastUpdateDate = result[i].lastUpdateDate.split(' ')[0]
                    // }
                    this.tableData = res;
                }
            })
        },
        //删除
        deleteRow(index,rows){
            let { effectiveDate } = rows[index];
            let dateNow = this.dataNow().split('/').reverse().join('-');
            this.contrastTime(effectiveDate,dateNow,rows,index)
        },
        //对比时间 => 删除
        contrastTime(date1,date2,rows,index){
            this.delete(rows,index)
            // var oDate1 = +new Date(date1);
            // var oDate2 = +new Date(date2);

            // oDate1 > oDate2 ?  this.delete(rows,index)
            // : oDate1 ==  oDate2 ? this.alert('当前时间只能修改,不能删除','warning')
            //                     : this.alert('历史时间记录不能删除或修改','warning')
            // if(oDate1 > oDate2){
            //     this.delete(rows,index)
            // }else if(oDate1 ==  oDate2){
            //     this.alert('当前时间只能修改,不能删除','warning')
            // }else {
            //     this.alert('历史时间记录不能删除或修改','warning')
            // }
        },
        //删除提示
        delete(rows,index){
            let { typeCode,effectiveDate,orderDisId} = rows[index] ;
            let userId = sessionStorage.getItem("userId") ;
            //effectiveDate = effectiveDate.split('-').reverse().join('/');
            let params = {
                act : 'delOrderDiscount',
                orderDisId : orderDisId,
                userId
            }
            this.$confirm('此操作将永久删除,是否继续？','提示',{
                confirmButtonText : '确定',
                cancelButtonText : '取消',
                type:'warning'
            }).then(() => {
                this.delType(params).then((res) =>{
                    if(res.data.status == true){
                        this.promptMsg('删除成功',"success");
                        let { typeCode }= this.$route.query ;
                        this.refreshType(typeCode);
                    }else{
                        res.data.msg ? this.alert(res.data.msg,'warning') : this.alert('删除失败','warning');
                    }
                })
            }).catch((error) => {
                this.$message({
                    type :'info',
                    message: '已取消删除!'
                })
            }) 
        },
        /**
         * 对比时间
         */
        contrastTime2(date1,date2,rows,index){
            var oDate1 = +new Date(date1);
            var oDate2 = +new Date(date2);
            if(oDate1 >= oDate2){
                this.openPrice =false;
                this.openDate = true;
                this.openDiscount=false;
                this.ruleForm.price = rows[index].unitPrice;
                this.act = 'editPrice' ;
            }else {
                this.alert('历史时间记录不能删除或修改','warning');
                this.openPrice = true;
                this.openDate =true;
                this.openDiscount=false;
                this.ruleForm.price = rows[index].unitPrice;
            }
        },
        //修改
        revise(index,rows){
            let {effectiveDate,discount,couponCount,orderDisId} = rows[index];
            let dateNow = this.dataNow().split('/').reverse().join('-');
            this.contrastTime2(effectiveDate,dateNow,rows,index);
            this.ruleForm.effectiveDate = effectiveDate;
            this.ruleForm.couponCount = couponCount;
            this.ruleForm.discount=discount;
            this.ruleForm.orderDisId=orderDisId;
            
        }
    }
}
</script>
